module.exports = __webpack_public_path__ + "img/karpicko_2018_sm.ce002182.jpg";